module.exports = __webpack_public_path__ + "img/menu-bz.30b88c62.png";